import { useState } from 'react';
import CatalogBrands from '../catalog/CatalogBrands';
import CatalogCategories from '../catalog/CatalogCategories';
import CatalogProducts from '../catalog/CatalogProducts';
import CatalogAttributes from '../catalog/CatalogAttributes';
import CatalogTags from '../catalog/CatalogTags';
import CatalogStores from '../catalog/CatalogStores';

export default function CatalogTable() {
    const [activeTab, setActiveTab] = useState<'brands' | 'categories' | 'products' | 'attributes' | 'tags' | 'stores'>('brands');

    return (
        <div className="space-y-6">
            {/* Main Tabs */}
            <div className="flex space-x-2 border-b border-gray-200 dark:border-gray-700 pb-2 overflow-x-auto">
                {['brands', 'categories', 'products', 'attributes', 'tags', 'stores'].map((tab) => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab as any)}
                        className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors capitalize ${activeTab === tab
                            ? 'bg-brand-500 text-white'
                            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800'
                            }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {/* Content Areas */}
            <div className="mt-6">
                {activeTab === 'brands' && <CatalogBrands />}
                {activeTab === 'categories' && <CatalogCategories />}
                {activeTab === 'products' && <CatalogProducts />}
                {activeTab === 'attributes' && <CatalogAttributes />}
                {activeTab === 'tags' && <CatalogTags />}
                {activeTab === 'stores' && <CatalogStores />}
            </div>
        </div>
    );
}
